// Generated from the support.monei.com -> docs.monei.com migration mapping.
// ID is the numeric Zendesk article/section/category ID that appeared in the old support.monei.com URL.
const DOCS_LINKS: Record<string, string> = {
  '360003378897': 'https://docs.monei.com/getting-started/',
  '360003378937': 'https://docs.monei.com/',
  '360003378957': 'https://docs.monei.com/payment-methods/overview/',
  '360003378977': 'https://docs.monei.com/',
  '360003383238': 'https://docs.monei.com/payments/overview/',
  '360003383258': 'https://docs.monei.com/manage-account/customization/',
  '360003383278': 'https://docs.monei.com/onboarding/onboarding-by-country/',
  '360003705137': 'https://docs.monei.com/partners-connect/affiliate-program/',
  '360003757258': 'https://docs.monei.com/monei-pay/overview/',
  '360005119037': 'https://docs.monei.com/manage-account/payouts-and-settlements/',
  '360005119057': 'https://docs.monei.com/payment-methods/overview/',
  '360005119097': 'https://docs.monei.com/payment-methods/bizum/',
  '360005119117': 'https://docs.monei.com/payment-methods/card/',
  '360005119177': 'https://docs.monei.com/payments/refunds/',
  '360005119217': 'https://docs.monei.com/e-commerce/woocommerce/',
  '360005119557': 'https://docs.monei.com/onboarding/onboarding-by-country/#spain',
  '360005119597': 'https://docs.monei.com/onboarding/onboarding-by-country/#andorra',
  '360005119737': 'https://docs.monei.com/manage-account/monei-fees/',
  '360005142338': 'https://docs.monei.com/getting-started/',
  '360005144558': 'https://docs.monei.com/',
  '360005144578': 'https://docs.monei.com/payment-methods/paypal/',
  '360005144598': 'https://docs.monei.com/payment-methods/apple-pay/',
  '360005144618': 'https://docs.monei.com/payment-methods/google-pay/',
  '360005144658': 'https://docs.monei.com/payments/overview/',
  '360005144678': 'https://docs.monei.com/subscriptions/overview/',
  '360005144718': 'https://docs.monei.com/payments/pay-by-link/',
  '360005144798': 'https://docs.monei.com/e-commerce/shopify/monei-bizum/',
  '360005145038': 'https://docs.monei.com/onboarding/onboarding-by-country/',
  '360005145058': 'https://docs.monei.com/manage-account/customization/',
  '360005172858': 'https://docs.monei.com/',
  '360005780297': 'https://docs.monei.com/partners-connect/affiliate-program/',
  '360005814098': 'https://docs.monei.com/partners-connect/affiliate-program/#promote',
  '360005899978': 'https://docs.monei.com/monei-pay/using-the-app/#getting-started',
  '360017801677': 'https://docs.monei.com/get-started/get-started-with-monei/',
  '360017801777': 'https://docs.monei.com/get-started/get-started-with-monei/',
  '360017801817': 'https://docs.monei.com/payment-methods/overview/',
  '360017801837': 'https://docs.monei.com/onboarding/onboarding-by-country/',
  '360017801857': 'https://docs.monei.com/onboarding/verification/#why-id',
  '360017801877': 'https://dashboard.monei.com/?action=signIn',
  '360017801897': 'https://docs.monei.com/payments/currencies/',
  '360017812857': 'https://docs.monei.com/manage-account/payouts-and-settlements/#iban',
  '360017812877': 'https://docs.monei.com/manage-account/accessing-your-dashboard/#password-reset',
  '360017812897': 'https://docs.monei.com/manage-account/accessing-your-dashboard/#phone-support',
  '360017812917': 'https://docs.monei.com/payment-methods/overview/',
  '360017812937': 'https://docs.monei.com/payment-methods/paypal/',
  '360017813117': 'https://docs.monei.com/payments/refunds/',
  '360017813277': 'https://docs.monei.com/payments/refunds/#cancel',
  '360017813317': 'https://docs.monei.com/payments/refunds/#different-card',
  '360017813357': 'https://docs.monei.com/payments/pay-by-link/#manual-payment',
  '360017813577': 'https://docs.monei.com/e-commerce/shopify/monei-bizum/',
  '360017813637': 'https://docs.monei.com/e-commerce/woocommerce/',
  '360017814717': 'https://docs.monei.com/manage-account/customization/#checkout-appearance',
  '360017814877': 'https://docs.monei.com/onboarding/onboarding-by-country/#spain',
  '360017911337': 'https://docs.monei.com/payment-methods/paypal/',
  '360017911957': 'https://docs.monei.com/payment-methods/card/',
  '360017944898': 'https://docs.monei.com/onboarding/onboarding-by-country/',
  '360017945058':
    'https://docs.monei.com/onboarding/connect-redsys-tpv-virtual/#activate-with-redsys',
  '360017945078': 'https://docs.monei.com/getting-started/',
  '360017945098': 'https://docs.monei.com/onboarding/restricted-and-high-risk-businesses/',
  '360017945118': 'https://docs.monei.com/onboarding/verification/#website-checklist',
  '360017945138': 'https://docs.monei.com/onboarding/verification/#after-signup',
  '360017952598':
    'https://monei.notion.site/MONEI-Experts-Directory-f67ee72ce90c4e6eb6069ee4cf396b84',
  '360017952618': 'https://docs.monei.com/manage-account/accessing-your-dashboard/#cancel-account',
  '360017952658': 'https://docs.monei.com/manage-account/payouts-and-settlements/',
  '360017952778': 'https://docs.monei.com/payments/refunds/#where',
  '360017952818': 'https://docs.monei.com/payments/pay-by-link/',
  '360017953338': 'https://docs.monei.com/onboarding/onboarding-by-country/#availability',
  '360017953818': 'https://docs.monei.com/manage-account/customization/#custom-domain',
  '360017953858': 'https://docs.monei.com/onboarding/onboarding-by-country/#andorra',
  '360017954318': 'https://docs.monei.com/manage-account/monei-fees/',
  '360018044018': 'https://docs.monei.com/get-started/get-started-with-monei/#account-id',
  '360018044978': 'https://docs.monei.com/payment-methods/card/',
  '360018045518': 'https://docs.monei.com/payment-methods/card/',
  '360018046578': 'https://docs.monei.com/payment-methods/paypal/',
  '360018047698': 'https://docs.monei.com/payment-methods/bizum/',
  '360018047738': 'https://docs.monei.com/payment-methods/bizum/',
  '360018053238': 'https://docs.monei.com/get-started/connect-monei-to-your-website/#api-key',
  '360018053298': 'https://docs.monei.com/',
  '360018053418':
    'https://docs.monei.com/onboarding/restricted-and-high-risk-businesses/#dropshipping',
  '360018290877': 'https://docs.monei.com/payment-methods/google-pay/',
  '360018291337': 'https://docs.monei.com/payment-methods/google-pay/',
  '360018420758': 'https://docs.monei.com/payment-methods/google-pay/',
  '360018421198': 'https://docs.monei.com/payment-methods/google-pay/',
  '360018563878': 'https://docs.monei.com/e-commerce/shopify/monei-bizum/',
  '360019558038': 'https://docs.monei.com/payment-methods/apple-pay/',
  '360019623057': 'https://docs.monei.com/payment-methods/apple-pay/',
  '360019623077': 'https://docs.monei.com/payment-methods/apple-pay/',
  '360019623117': 'https://docs.monei.com/payment-methods/apple-pay/',
  '360019794278': 'https://docs.monei.com/payment-methods/apple-pay/',
  '360019794418': 'https://docs.monei.com/payment-methods/apple-pay/',
  '360020515658': 'https://docs.monei.com/partners-connect/affiliate-program/#promote',
  '360020516738': 'https://docs.monei.com/partners-connect/affiliate-program/#preguntas-frecuentes',
  '360020603817':
    'https://docs.monei.com/partners-connect/monei-affiliate-program-terms-and-conditions/',
  '360020794237': 'https://docs.monei.com/monei-pay/using-the-app/#getting-started',
  '360020966278': 'https://docs.monei.com/',
  '4406122388369': 'https://docs.monei.com/e-commerce/wix/',
  '4406122571025': 'https://docs.monei.com/e-commerce/wix/',
  '4406217514513': 'https://docs.monei.com/payments/currencies/#set-up',
  '4406822642577': 'https://docs.monei.com/onboarding/connect-redsys-tpv-virtual/',
  '4406830186129': 'https://docs.monei.com/manage-account/transaction-history/',
  '4406930783505': 'https://docs.monei.com/payment-methods/click-to-pay/',
  '4406930891537': 'https://docs.monei.com/payment-methods/click-to-pay/',
  '4406930971025': 'https://docs.monei.com/payment-methods/click-to-pay/',
  '4406930999697': 'https://docs.monei.com/payment-methods/click-to-pay/',
  '4406931055505': 'https://docs.monei.com/payment-methods/click-to-pay/',
  '4406931118481': 'https://docs.monei.com/payment-methods/click-to-pay/',
  '4406931154705': 'https://docs.monei.com/payment-methods/click-to-pay/',
  '4406938584337': 'https://docs.monei.com/payment-methods/click-to-pay/',
  '4412625758097': 'https://docs.monei.com/e-commerce/woocommerce/',
  '4412637024401': 'https://docs.monei.com/payment-methods/overview/',
  '4412643058833': 'https://docs.monei.com/payment-methods/overview/',
  '4413587453585': 'https://docs.monei.com/payment-methods/paypal/',
  '4413592008593': 'https://docs.monei.com/payment-methods/paypal/',
  '4413600005009': 'https://docs.monei.com/payment-methods/card/',
  '4413600600849': 'https://docs.monei.com/payment-methods/apple-pay/',
  '4413658282257': 'https://docs.monei.com/payment-methods/google-pay/',
  '4413658334609': 'https://docs.monei.com/payment-methods/click-to-pay/',
  '4413658506897': 'https://docs.monei.com/payment-methods/bizum/',
  '4413886523793': 'https://docs.monei.com/onboarding/restricted-and-high-risk-businesses/#cbd',
  '4414011433745': 'https://docs.monei.com/payment-methods/card/',
  '4414018565137': 'https://docs.monei.com/e-commerce/woocommerce/',
  '4416503871889': 'https://docs.monei.com/',
  '4416520191249': 'https://docs.monei.com/manage-account/monei-fees/#interchange',
  '4417209390865': 'https://docs.monei.com/testing/',
  '4417628602513': 'https://docs.monei.com/payments/orchestration/',
  '4417643896593': 'https://docs.monei.com/payments/orchestration/',
  '4417692136977': 'https://docs.monei.com/monei-pay/overview/',
  '4417692266513': 'https://docs.monei.com/monei-pay/using-the-app/#qr-payments',
  '4417692395921': 'https://docs.monei.com/monei-pay/using-the-app/#users',
  '4417692522641': 'https://docs.monei.com/monei-pay/using-the-app/#qr-payments',
  '4417696912145': 'https://docs.monei.com/monei-pay/using-the-app/#getting-started',
  '4417697036561': 'https://docs.monei.com/monei-pay/using-the-app/#test',
  '4417697234705': 'https://docs.monei.com/monei-pay/using-the-app/#customer-amount',
  '4417707055633': 'https://docs.monei.com/e-commerce/shopify/monei-bizum/',
  '4417709411729': 'https://docs.monei.com/monei-pay/using-the-app/#users',
  '4417709486737': 'https://docs.monei.com/monei-pay/using-the-app/#payment-methods',
  '4417709554193': 'https://docs.monei.com/monei-pay/using-the-app/#retail-prices',
  '4417709618193': 'https://docs.monei.com/monei-pay/using-the-app/#qr-payments',
  '4418024623377': 'https://docs.monei.com/onboarding/verification/#public-activities',
  '4418582113169': 'https://docs.monei.com/subscriptions/overview/#subscriptions-api',
  '4419317690129': 'https://docs.monei.com/onboarding/restricted-and-high-risk-businesses/#alcohol',
  '4419318584209': 'https://docs.monei.com/payments/pay-by-link/#without-website',
  '4419324309905': 'https://docs.monei.com/manage-account/accessing-your-dashboard/#leave-review',
  '4433164300177': 'https://docs.monei.com/payment-methods/paypal/',
  '4463392585105': 'https://docs.monei.com/payment-methods/bizum/',
  '4463510317713': 'https://docs.monei.com/payment-methods/bizum/',
  '4463568204433': 'https://docs.monei.com/payment-methods/bizum/',
  '4463699147025': 'https://docs.monei.com/testing/#c%C3%B3mo-probar-tus-integraciones',
  '4805156054673': 'https://docs.monei.com/manage-account/customization/#dynamic-descriptors',
  '4930190609297': 'https://docs.monei.com/onboarding/onboarding-by-country/#andorra',
  '5858447779473': 'https://docs.monei.com/e-commerce/prestashop/',
  '5859604372241': 'https://docs.monei.com/e-commerce/prestashop/',
  '5882529483537': 'https://docs.monei.com/manage-account/transaction-history/#download',
  '6167527597457': 'https://docs.monei.com/monei-pay/using-the-app/#download',
  '6394543988753': 'https://docs.monei.com/payment-methods/bizum/',
  '8260026805649': 'https://docs.monei.com/troubleshoot/payment-statuses/',
  '8418026491537': 'https://docs.monei.com/monei-pay/using-the-app/#refunds',
  '8418566197777': 'https://docs.monei.com/manage-account/transaction-history/#quick-view',
  '8419055964561': 'https://docs.monei.com/payments/pay-by-link/#business-types',
  '8419697096209': 'https://docs.monei.com/get-started/what-is-monei/',
  '8797620433937': 'https://docs.monei.com/monei-pay/using-the-app/#customize',
  '8966018940305': 'https://docs.monei.com/manage-account/accessing-your-dashboard/#users-roles',
  '9086412406801': 'https://docs.monei.com/payment-methods/bizum/',
  '10138482720145': 'https://docs.monei.com/get-started/what-is-monei/#how-it-works',
  '10431514400529': 'https://docs.monei.com/payment-methods/multibanco/',
  '10431601364113': 'https://docs.monei.com/payment-methods/multibanco/',
  '10431717564817': 'https://docs.monei.com/payment-methods/multibanco/',
  '10431739747089': 'https://docs.monei.com/payment-methods/multibanco/',
  '10431799258897': 'https://docs.monei.com/payment-methods/multibanco/',
  '10431939169937': 'https://docs.monei.com/payment-methods/multibanco/',
  '10960965930769': 'https://docs.monei.com/onboarding/payouts-suspended/#account-suspended',
  '12253203762449': 'https://docs.monei.com/monei-pay/using-the-app/#payment-requests',
  '12835117630737': 'https://docs.monei.com/partners-connect/about/',
  '13581473720977': 'https://dashboard.monei.com/?action=signIn',
  '15028355292689': 'https://docs.monei.com/payments/pay-by-link/#whatsapp',
  '17046659268369': 'https://docs.monei.com/subscriptions/overview/#automatic-retries',
  '17225333362833': 'https://docs.monei.com/subscriptions/overview/#custom-retries',
  '17481521409169': 'https://docs.monei.com/monei-pay/using-the-app/#receipts',
  '17482161916049': 'https://docs.monei.com/manage-account/stores-and-points-of-sale/',
  '17482452826001': 'https://docs.monei.com/monei-js/reference/#resultado-del-pago',
  '17482672721809': 'https://docs.monei.com/get-started/what-is-monei/#business-types',
  '17507402345105': 'https://docs.monei.com/payment-methods/mb-way/',
  '17507434930705': 'https://docs.monei.com/payment-methods/mb-way/',
  '17507468723601': 'https://docs.monei.com/payment-methods/mb-way/',
  '17507477197329': 'https://docs.monei.com/payment-methods/mb-way/',
  '17507491878417': 'https://docs.monei.com/payment-methods/mb-way/',
  '17507541090449': 'https://docs.monei.com/payment-methods/mb-way/',
  '17507548878609': 'https://docs.monei.com/payment-methods/mb-way/',
  '17507573343121': 'https://docs.monei.com/payment-methods/mb-way/',
  '17507594592657': 'https://docs.monei.com/payment-methods/mb-way/',
  '17507605624465': 'https://docs.monei.com/payment-methods/mb-way/',
  '17508182283537': 'https://docs.monei.com/payment-methods/overview/',
  '17508293213841': 'https://docs.monei.com/payment-methods/overview/',
  '17508316639249': 'https://docs.monei.com/payment-methods/overview/',
  '17508415626897': 'https://docs.monei.com/payment-methods/overview/',
  '17508462782865': 'https://docs.monei.com/payment-methods/overview/',
  '17508510091793': 'https://docs.monei.com/payment-methods/overview/',
  '17508528399761': 'https://docs.monei.com/payment-methods/overview/',
  '17508545819537': 'https://docs.monei.com/payment-methods/overview/',
  '17508557216529': 'https://docs.monei.com/payment-methods/overview/',
  '17508582119313': 'https://docs.monei.com/payment-methods/overview/',
  '18102642780561': 'https://docs.monei.com/manage-account/email-notifications/',
  '18277572503441': 'https://docs.monei.com/onboarding/restricted-and-high-risk-businesses/',
  '18677686522769': 'https://docs.monei.com/partners-connect/about/',
  '18699790375057': 'https://docs.monei.com/partners-connect/about/',
  '18699832559249': 'https://docs.monei.com/partners-connect/about/#what-is-it',
  '18700013135249': 'https://docs.monei.com/partners-connect/about/#who-uses-it',
  '18700081270417': 'https://docs.monei.com/partners-connect/about/#payment-methods',
  '18700085095569': 'https://docs.monei.com/partners-connect/about/',
  '18700241106449': 'https://docs.monei.com/partners-connect/about/#how-it-works',
  '18700281236369': 'https://docs.monei.com/partners-connect/about/#register-directly',
  '18700369618577': 'https://docs.monei.com/partners-connect/about/#onboarding-issues',
  '18701615290257': 'https://docs.monei.com/partners-connect/about/#visibility',
  '18701675650321': 'https://docs.monei.com/monei-connect/#integraci%C3%B3n',
  '18701678287249': 'https://docs.monei.com/monei-connect/',
  '18701772392977': 'https://docs.monei.com/monei-connect/#api-keys',
  '18701817725201': 'https://docs.monei.com/partners-connect/about/#custom-integrations',
  '18701892127377': 'https://docs.monei.com/partners-connect/about/#kyc',
  '18701938624657': 'https://docs.monei.com/partners-connect/about/#kyc',
  '18702007663249': 'https://docs.monei.com/partners-connect/about/#kyc',
  '18709966015505': 'https://docs.monei.com/onboarding/verification/#kyc',
  '18710614770577': 'https://docs.monei.com/onboarding/verification/#account-statuses',
  '18711908232721': 'https://docs.monei.com/partners-connect/about/#test-integration',
  '18712313481233': 'https://docs.monei.com/partners-connect/about/#integration-support',
  '18712418579473': 'https://docs.monei.com/partners-connect/about/#tracking',
  '19045218853777': 'https://docs.monei.com/manage-account/stores-and-points-of-sale/',
  '19254164122385': 'https://docs.monei.com/e-commerce/shopify/monei-bizum/',
  '19575511200401': 'https://docs.monei.com/payment-methods/bizum/',
  '21028338276369': 'https://docs.monei.com/monei-pay/using-the-app/#home',
  '21028436982545': 'https://docs.monei.com/get-started/get-started-with-monei/#payment-methods',
  '21532495999761':
    'https://docs.monei.com/get-started/what-is-monei/#ventajas-clave-de-elegir-monei-como-proveedor-de-servicios-de-pago',
  '43968277874449':
    'https://docs.monei.com/fraud-prevention/fraud-detector-how-it-works-configuration-and-best-practices/',
  '43968613098641':
    'https://docs.monei.com/fraud-prevention/fraud-detector-how-it-works-configuration-and-best-practices/'
};

const DOCS_HOME = 'https://docs.monei.com/';
const CONTACT_SUPPORT = 'https://docs.monei.com/contact-support/';

/**
 * The one page describing how to reach MONEI support. It replaced the Zendesk ticket form, which
 * went away with support.monei.com.
 */
export function getContactSupportUrl(language: string): string {
  return language === 'es'
    ? CONTACT_SUPPORT.replace('https://docs.monei.com/', 'https://docs.monei.com/es/')
    : CONTACT_SUPPORT;
}

/**
 * Resolves an old support.monei.com Zendesk ID (or none, for the support home page)
 * to its docs.monei.com destination, localized for the given site language.
 * Spanish gets a /es/ path prefix (docs.monei.com only); other domains
 * (e.g. dashboard.monei.com, notion.site) and other locales are unaffected.
 */
export function getDocsUrl(id: string | null | undefined, language: string): string {
  const url = (id && DOCS_LINKS[id]) || DOCS_HOME;
  if (language === 'es' && url.startsWith('https://docs.monei.com/')) {
    return url.replace('https://docs.monei.com/', 'https://docs.monei.com/es/');
  }
  return url;
}
